import { render, staticRenderFns } from "./reward-games.vue?vue&type=template&id=3c8879f2"
import script from "./reward-games.vue?vue&type=script&lang=js"
export * from "./reward-games.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports